import React from 'react';
import { AgendaView } from '@bryntum/calendar';
import { createWidget, shouldComponentUpdate, processWidgetContent } from './WrapperHelper.js';
export class BryntumAgendaView extends React.Component {
    constructor() {
        super(...arguments);
        this.processWidgetContent = processWidgetContent;
    }
    componentDidMount() {
        this.instance = createWidget(this);
    }
    componentWillUnmount() {
        var _a, _b;
        (_b = (_a = this.instance) === null || _a === void 0 ? void 0 : _a.destroy) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
    shouldComponentUpdate(nextProps, nextState) {
        return shouldComponentUpdate(this, nextProps, nextState);
    }
    render() {
        const className = `b-react-agenda-view-container`;
        return (React.createElement("div", { className: className, ref: (element) => (this.element = element) }));
    }
}
BryntumAgendaView.instanceClass = AgendaView;
BryntumAgendaView.instanceName = 'AgendaView';
BryntumAgendaView.configNames = [
    'activationKey',
    'adopt',
    'animateFilterRemovals',
    'animateRemovingRows',
    'ariaDescription',
    'ariaLabel',
    'autoHeight',
    'bbar',
    'bodyCls',
    'bubbleEvents',
    'callOnFunctions',
    'collapsible',
    'config',
    'contentElementCls',
    'contextMenuTriggerEvent',
    'defaultRegion',
    'descriptionRenderer',
    'destroyStore',
    'disableGridColumnIdWarning',
    'disableGridRowModelWarning',
    'dock',
    'drawer',
    'elementAttributes',
    'enableSticky',
    'enableTextSelection',
    'endDate',
    'eventFilter',
    'eventHeaderRenderer',
    'eventHeight',
    'eventListTimeFormat',
    'eventRenderer',
    'eventRowSpacing',
    'eventSorter',
    'fillLastColumn',
    'fixedRowHeight',
    'footer',
    'formulaProviders',
    'fullRowRefresh',
    'getPrimaryResource',
    'getRowHeight',
    'header',
    'hideEventOverflow',
    'hideHorizontalScrollbar',
    'hoverCls',
    'ignoreParentReadOnly',
    'listeners',
    'listRangeMenu',
    'loadMask',
    'loadMaskDefaults',
    'loadMaskError',
    'localizable',
    'maskDefaults',
    'masked',
    'monitorResize',
    'nonWorkingDays',
    'owner',
    'plugins',
    'preserveFocusOnDatasetChange',
    'preserveScrollOnDatasetChange',
    'preventTooltipOnTouch',
    'relayStoreEvents',
    'resizable',
    'resizeToFitIncludesHeader',
    'resourceImagePath',
    'responsive',
    'responsiveLevels',
    'responsiveRoot',
    'responsiveState',
    'responsiveTarget',
    'ripple',
    'rootElement',
    'scrollerClass',
    'scrollManager',
    'selectorButton',
    'selectorMenuItem',
    'shortEventCls',
    'shortEventDuration',
    'showBullet',
    'showDirty',
    'showResourceAvatars',
    'startDate',
    'stateful',
    'statefulEvents',
    'stateId',
    'stateProvider',
    'strips',
    'subGridConfigs',
    'syncMask',
    'tab',
    'tabBarItems',
    'tbar',
    'timeFormat',
    'type',
    'ui',
    'weekStartDay',
    'weight'
];
BryntumAgendaView.propertyConfigNames = [
    'alignSelf',
    'allowDragCreate',
    'allowDragMove',
    'allowDragResize',
    'alwaysShowCurrentDate',
    'animateTimeShift',
    'animateTreeNodeToggle',
    'appendTo',
    'ariaLive',
    'autoCreate',
    'cellEllipsis',
    'cls',
    'collapsed',
    'columnLines',
    'columns',
    'data',
    'dataset',
    'date',
    'dateFilter',
    'dateFormat',
    'dateSeparator',
    'defaultScrollOptions',
    'descriptionFormat',
    'disabled',
    'dragUnit',
    'emptyText',
    'enableUndoRedoKeys',
    'eventTimeRenderer',
    'extendAllDayEndDay',
    'extraData',
    'filterEventResources',
    'fixedDuration',
    'flex',
    'height',
    'hidden',
    'hideFooters',
    'hideHeaders',
    'hideNonWorkingDays',
    'id',
    'insertBefore',
    'insertFirst',
    'keyMap',
    'longPressTime',
    'margin',
    'maxDate',
    'maxHeight',
    'maxWidth',
    'minDate',
    'minHeight',
    'minWidth',
    'offsetStartsBeforeEvents',
    'onBeforeAutoCreate',
    'onBeforeCancelCellEdit',
    'onBeforeCancelRowEdit',
    'onBeforeCellEditStart',
    'onBeforeCellRangeDelete',
    'onBeforeCellRangeEdit',
    'onBeforeChangeDate',
    'onBeforeColumnDragStart',
    'onBeforeColumnDropFinalize',
    'onBeforeColumnResize',
    'onBeforeCopy',
    'onBeforeCSVExport',
    'onBeforeDestroy',
    'onBeforeExcelExport',
    'onBeforeFillHandleDragStart',
    'onBeforeFinishCellEdit',
    'onBeforeFinishRowEdit',
    'onBeforeHide',
    'onBeforePaste',
    'onBeforePdfExport',
    'onBeforeRenderRow',
    'onBeforeRenderRows',
    'onBeforeResponsiveStateChange',
    'onBeforeRowCollapse',
    'onBeforeRowExpand',
    'onBeforeSelectionChange',
    'onBeforeSetRecord',
    'onBeforeShow',
    'onBeforeStartRowEdit',
    'onBeforeStateApply',
    'onBeforeStateSave',
    'onBeforeToggleGroup',
    'onBeforeToggleNode',
    'onCancelCellEdit',
    'onCatchAll',
    'onCellClick',
    'onCellContextMenu',
    'onCellDblClick',
    'onCellMapPopulated',
    'onCellMenuBeforeShow',
    'onCellMenuItem',
    'onCellMenuShow',
    'onCellMenuToggleItem',
    'onCellMouseEnter',
    'onCellMouseLeave',
    'onCellMouseOut',
    'onCellMouseOver',
    'onCollapse',
    'onCollapseNode',
    'onColumnDrag',
    'onColumnDragStart',
    'onColumnDrop',
    'onColumnResize',
    'onColumnResizeStart',
    'onContextMenuItem',
    'onContextMenuToggleItem',
    'onCopy',
    'onDataChange',
    'onDayCellPopulated',
    'onDestroy',
    'onDirtyStateChange',
    'onDragSelecting',
    'onEventAutoCreated',
    'onEventPropagate',
    'onExpand',
    'onExpandNode',
    'onFileDrop',
    'onFillHandleBeforeDragFinalize',
    'onFillHandleDrag',
    'onFillHandleDragAbort',
    'onFillHandleDragEnd',
    'onFillHandleDragStart',
    'onFinishCellEdit',
    'onFinishRowEdit',
    'onFocusIn',
    'onFocusOut',
    'onGridRowBeforeDragStart',
    'onGridRowBeforeDropFinalize',
    'onGridRowDrag',
    'onGridRowDragAbort',
    'onGridRowDragStart',
    'onGridRowDrop',
    'onHeaderClick',
    'onHeaderMenuBeforeShow',
    'onHeaderMenuItem',
    'onHeaderMenuShow',
    'onHeaderMenuToggleItem',
    'onHide',
    'onLockRows',
    'onMouseOut',
    'onMouseOver',
    'onPaint',
    'onPaste',
    'onPdfExport',
    'onRangeChange',
    'onReadOnly',
    'onRecompose',
    'onRefresh',
    'onRenderRow',
    'onRenderRows',
    'onResize',
    'onResponsive',
    'onResponsiveStateChange',
    'onRowCollapse',
    'onRowExpand',
    'onRowMouseEnter',
    'onRowMouseLeave',
    'onScroll',
    'onSelectionChange',
    'onSelectionModeChange',
    'onShiftIncrementChange',
    'onShow',
    'onSplit',
    'onSplitterCollapseClick',
    'onSplitterDragEnd',
    'onSplitterDragStart',
    'onSplitterExpandClick',
    'onStartCellEdit',
    'onStartRowEdit',
    'onSubGridCollapse',
    'onSubGridExpand',
    'onToggleGroup',
    'onToggleNode',
    'onToolClick',
    'onTopDateChange',
    'onUnlockRows',
    'onUnsplit',
    'pastEventCls',
    'preserveScroll',
    'range',
    'readOnly',
    'rowHeight',
    'rowLines',
    'rtl',
    'scrollable',
    'selectionMode',
    'settingsButton',
    'shiftIncrement',
    'shortDateFormat',
    'shortDateTimeFormat',
    'showEmptyDates',
    'stackMultiDayEvents',
    'stateSettings',
    'store',
    'syncCalendarDate',
    'syncViewDate',
    'title',
    'tools',
    'transitionDuration',
    'width'
];
BryntumAgendaView.propertyNames = [
    'dayCellCls',
    'firstVisibleCell',
    'firstVisibleDate',
    'focusVisible',
    'hasChanges',
    'lastVisibleCell',
    'lastVisibleDate',
    'originalStore',
    'parent',
    'selectedCell',
    'selectedCells',
    'selectedRecord',
    'selectedRecords',
    'selectedRows',
    'state',
    'tooltip'
];
//# sourceMappingURL=BryntumAgendaView.js.map